import React from 'react';

import { useAppMonitor } from '../../../monitor';
import { resetView } from '../../../store/actions/cameraActions';
import { useAppDispatch } from '../../hooks';
import { ResetViewIcon } from '../../misc/icons/ResetViewIcon';
import { ToolbarIconButton } from '../top/ToolbarIconButton';

export default function ResetViewButton() {
  const monitor = useAppMonitor();
  const dispatch = useAppDispatch();

  return (
    <ToolbarIconButton
      icon={<ResetViewIcon />}
      title="Reset View (Esc)"
      onClick={() => {
        dispatch(resetView());
        monitor.recordInteraction('Reset View via toolbar button');
      }}
    />
  );
}
